import axios, { AxiosRequestConfig } from 'axios';
import { useToken } from '../contexts/tokenContext';
import { GroupType } from '../entities/GroupType';

export const useUpdateGroupType = () => {
	const token = useToken();
	return async (groupTypeId: number, form: any): Promise<GroupType | null> => {
		try {
			if (!token?.accessToken) {
				return null;
			}

			delete form.id;

			const params: AxiosRequestConfig = {
				method: 'PATCH',
				url: `/group_type/${groupTypeId}`,
				data: form,
				withCredentials: true,
			};
			const result = await axios.request(params);
			return result.data;
		} catch (error) {
			throw error;
		}
	};
};
